import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { OptiBaySystemFamily, OptiBaySubfamily, OptiBayTestPath } from '@/types/optibay';

const sb = supabase as any;

export function useOptiBayFamilies() {
  return useQuery({
    queryKey: ['optibay-families'],
    queryFn: async (): Promise<OptiBaySystemFamily[]> => {
      const { data, error } = await sb
        .from('optibay_system_families')
        .select('*')
        .eq('is_active', true)
        .eq('is_diagnostic_root', true)
        .order('sort_order');
      if (error) throw error;
      return (data ?? []) as OptiBaySystemFamily[];
    },
    staleTime: 1000 * 60 * 30,
  });
}

export function useOptiBaySubfamilies(familyId: string | null) {
  return useQuery({
    queryKey: ['optibay-subfamilies', familyId],
    queryFn: async (): Promise<OptiBaySubfamily[]> => {
      if (!familyId) return [];
      const { data, error } = await sb
        .from('optibay_subfamilies')
        .select('*')
        .eq('family_id', familyId)
        .eq('is_active', true)
        .order('sort_order');
      if (error) throw error;
      return (data ?? []) as OptiBaySubfamily[];
    },
    enabled: !!familyId,
    staleTime: 1000 * 60 * 30,
  });
}

export function useOptiBayTestPaths(familyId: string | null) {
  return useQuery({
    queryKey: ['optibay-test-paths', familyId],
    queryFn: async (): Promise<OptiBayTestPath[]> => {
      if (!familyId) return [];
      const { data, error } = await sb
        .from('optibay_test_paths')
        .select('*')
        .eq('family_id', familyId)
        .eq('is_active', true)
        .order('sort_order');
      if (error) throw error;
      return (data ?? []) as OptiBayTestPath[];
    },
    enabled: !!familyId,
    staleTime: 1000 * 60 * 30,
  });
}
